import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

// TODO Derive these from the theme file and what's actually available

const colorNames = themeUtilities.validColorNames

export const ColorsPropTypes = (props: any, propName: any, componentName: any) => {
  // Check color names first:
  if (props[propName] && !colorNames.includes(props[propName]) && !/^#[a-fA-F0-9]{8}/.test(props[propName])) {
    return new Error(
      `Invalid prop ${propName} of "${props[propName]}" supplied to ${componentName}. Validation failed.`
    )
  }
}

export type FontSizesPropTypes = typeof themeUtilities.validFontSizeNames
export type FontWeightsPropTypes = 'lighter' | 'normal' | 'bolder'
export type HorizontalAlignmentsPropTypes = 'left' | 'center' | 'right'
export type SpacingPropTypes = 'none' | 'small' | 'default' | 'medium' | 'large' | 'extraLarge' | 'padding'
